import Vue from 'vue'
import Router from 'vue-router'
import MainNav from './main-nav'
import FooterNav from './footer-nav'

Vue.use(Router);

const routes = MainNav.concat(FooterNav);

export default new Router({
  mode: 'history',
  linkActiveClass: 'active',
  routes:routes.filter((r)=>r.path !==undefined)
})



// WEBPACK FOOTER //
// ./src/router/index.js